import request from '@/utils/request'

export function swipeCard(params) {
  return request({
    url: '/clock?card_no',
    method: 'get',
    params
  })
}

export function help(data) {
  return request({
    url: '/help',
    method: 'post',
    data
  })
}

export function read(data) {
  return request({
    url: '/read',
    method: 'post',
    data
  })
}

export function done(data) {
  return request({
    url: '/done',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/swipeCard.js